import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

// modules
import auth from "./auth.module";
import selfcare from "./selfcare.module";
import customPermissionDetail from "./customPermissionDetail.module";
import { report } from "./report";
import topup from "./topup";

const debug = process.env.VUE_APP_ENV !== "production";
export default new Vuex.Store({
  strict: false,
  modules: {
    auth,
    customPermissionDetail,
    report,
    topup,
    selfcare,
  },
});
